var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1938 2246",
    style: {
      enableBackground: "new 0 0 1938 2246"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#CCEEFF;}\n\t.st2{display:inline;opacity:0.35;}\n\t.st3{fill:#262F6A;}\n\t.st4{fill:#000072;}\n\t.st5{display:inline;}\n\t.st6{fill:#D2E7F9;}\n\t.st7{display:inline;opacity:0.3;}\n\t.st8{display:inline;opacity:0.55;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:#19AFF9;}\n\t.st11{display:inline;opacity:0.5;}\n\t.st12{display:inline;opacity:0.15;}\n\t.st13{fill:#D16913;}\n\t.st14{opacity:0.35;}\n\t.st15{fill:#00BA52;}\n\t.st16{fill:#7D91AD;}\n\t.st17{fill:#001C35;}\n\t.st18{opacity:0.5;}\n\t.st19{opacity:0.29;}\n\t.st20{opacity:0.2;}\n\t.st21{fill:#F3F1A5;}\n\t.st22{fill:#5F5A57;}\n\t.st23{fill:#4A83FF;}\n\t.st24{display:inline;opacity:0.51;}\n\t.st25{fill:#EC1C24;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -530,
    y: -1031,
    className: "st1",
    width: 4000,
    height: 4000
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2628.6,2106.9l-479.9-83.2c-49.5-8.6-82.7-55.7-74.1-105.3l171.1-986.5c8.6-49.5,55.7-82.7,105.3-74.1 l479.9,83.2c49.5,8.6,82.7,55.7,74.1,105.3l-171.1,986.5C2725.2,2082.3,2678.1,2115.5,2628.6,2106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2644.3,2110.8c-5.4,0-10.8-0.5-16.2-1.4l-479.9-83.2c-50.8-8.8-85-57.3-76.2-108.1l171.1-986.5 c4.3-24.6,17.9-46.1,38.3-60.5c20.4-14.4,45.2-20,69.9-15.7l479.9,83.2c50.8,8.8,85,57.3,76.2,108.1l-171.1,986.5 c-4.3,24.6-17.9,46.1-38.3,60.5C2682,2104.9,2663.4,2110.8,2644.3,2110.8z M2335.1,858.9c-18.1,0-35.7,5.5-50.8,16.2 c-19.3,13.6-32.2,34-36.2,57.3L2077,1918.8c-8.3,48.1,24,94,72.1,102.4l479.9,83.2c23.3,4,46.8-1.2,66.1-14.9 c19.3-13.6,32.2-34,36.2-57.3l171.1-986.5c8.3-48.1-24-94-72.1-102.4l-479.9-83.2C2345.3,859.3,2340.2,858.9,2335.1,858.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2520,2002.5l-479.9-83.2c-49.5-8.6-82.7-55.7-74.1-105.3L2137,827.5c8.6-49.5,55.7-82.7,105.3-74.1 l479.9,83.2c49.5,8.6,82.7,55.7,74.1,105.3l-171.1,986.5C2616.7,1977.9,2569.5,2011.1,2520,2002.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2535.6,2006.3c-5.3,0-10.6-0.4-16-1.4l-479.9-83.2c-50.8-8.8-85-57.3-76.2-108.1l171.1-986.5 c4.3-24.6,17.9-46.1,38.3-60.5c20.4-14.4,45.2-20,69.9-15.7l479.9,83.2c50.8,8.8,85,57.3,76.2,108.1l-171.1,986.5 C2619.8,1974.2,2580.2,2006.3,2535.6,2006.3z M2520.4,2000c48.1,8.3,94-24,102.4-72.1l171.1-986.5c8.3-48.1-24-94-72.1-102.4 l-479.9-83.2c-23.3-4-46.8,1.2-66.1,14.9c-19.3,13.6-32.2,34-36.2,57.3l-171.1,986.5c-8.3,48.1,24,94,72.1,102.4L2520.4,2000z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2793.3,941.3l-171.1,986.5c-8.6,49.5-55.7,82.7-105.3,74.1l-479.9-83.2c-37.5-6.5-65.6-35-73.4-69.9 c12.1,10.3,26.9,17.7,43.8,20.6l479.9,83.2c49.5,8.6,96.7-24.6,105.3-74.1L2763.8,892c2.1-12.2,1.7-24.1-0.8-35.4 C2786.4,877,2799,908.6,2793.3,941.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2794,900.6c-11-8-23.9-13.6-38.1-16.1l-479.9-83.2c-49.5-8.6-96.7,24.6-105.3,74.1l-171.1,986.5 c-2.5,14.3-1.5,28.2,2.3,41.3c-27.1-19.8-42.2-53.9-36.1-89.2l171.1-986.5c8.6-49.5,55.7-82.7,105.3-74.1l479.9,83.2 C2757.5,842.7,2784.5,868.4,2794,900.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2535.6,2021.3c-6.1,0-12.3-0.5-18.6-1.6c0,0,0,0,0,0l-479.9-83.2c-59-10.2-98.6-66.5-88.4-125.5 l171.1-986.5c5-28.6,20.7-53.5,44.4-70.2c23.7-16.7,52.5-23.2,81.1-18.2l479.9,83.2c59,10.2,98.6,66.5,88.4,125.5l-171.1,986.5 C2633.3,1984,2587.4,2021.3,2535.6,2021.3z M2523,1985.2c39.9,6.9,78.1-19.9,85-59.9l171.1-986.5c6.9-40-19.9-78.1-59.9-85 l-479.9-83.2c-19.3-3.3-38.9,1-54.9,12.3c-16.1,11.3-26.8,28.2-30.1,47.6L1983.2,1817c-6.9,40,19.9,78.1,59.9,85L2523,1985.2 L2523,1985.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2528.9,1829l-438.9-76.1c-18.9-3.3-31.6-21.3-28.3-40.2l137.6-793.4c3.3-18.9,21.3-31.6,40.2-28.3 l438.9,76.1c18.9,3.3,31.6,21.3,28.3,40.2l-137.6,793.4C2565.9,1819.6,2547.9,1832.3,2528.9,1829z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2534.9,1832c-2.1,0-4.2-0.2-6.4-0.6l-438.9-76.1c-20.3-3.5-33.9-22.9-30.4-43.1l137.6-793.4 c1.7-9.8,7.1-18.4,15.3-24.1c8.1-5.7,18-8,27.8-6.2l438.9,76.1c20.3,3.5,33.9,22.9,30.4,43.1l-137.6,793.4 C2568.5,1819.2,2552.7,1832,2534.9,1832z M2529.4,1826.6c17.5,3,34.3-8.8,37.3-26.3l137.6-793.4c3-17.5-8.8-34.3-26.3-37.3 l-438.9-76.1c-8.5-1.5-17.1,0.4-24.1,5.4c-7,5-11.7,12.4-13.2,20.9l-137.6,793.4c-3,17.5,8.8,34.3,26.3,37.3L2529.4,1826.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2710.1,1012l-137.6,793.4c-1.8,10.3-7.9,18.6-16.1,23.7c-7,4.3-15.4,6.1-24.1,4.6l-438.9-76.1 c-18.9-3.3-31.6-21.3-28.3-40.2L2202.7,924c3.3-18.9,21.3-31.6,40.2-28.3l438.9,76.1C2700.7,975.1,2713.4,993.1,2710.1,1012z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -650.6043 2171.2454)",
    className: "st4",
    cx: 2295.6,
    cy: 1871,
    rx: 37.5,
    ry: 37.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2508.1,1311.5l-290.5-50.4c-13.2-2.3-22.1-14.9-19.8-28.1l32.4-186.7c2.3-13.2,14.9-22.1,28.1-19.8 l290.5,50.4c13.2,2.3,22.1,14.9,19.8,28.1l-32.4,186.7C2533.9,1304.9,2521.3,1313.8,2508.1,1311.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8175 -0.5759 0.5759 0.8175 -149.6202 1486.8748)",
    className: "st9",
    cx: 2271.6,
    cy: 979.6,
    rx: 29.4,
    ry: 29.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2440.5,1701.3l-290.5-50.4c-13.2-2.3-22.1-14.9-19.8-28.1l32.4-186.7c2.3-13.2,14.9-22.1,28.1-19.8 l290.5,50.4c13.2,2.3,22.1,14.9,19.8,28.1l-32.4,186.7C2466.3,1694.8,2453.7,1703.6,2440.5,1701.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8175 -0.5759 0.5759 0.8175 -386.4614 1519.0649)",
    className: "st9",
    cx: 2204,
    cy: 1369.4,
    rx: 29.4,
    ry: 29.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2624,1508.9l-51.4,296.6c-1.8,10.3-7.9,18.6-16.1,23.7l-371.6-801.5l18-103.6 c3.3-18.9,21.3-31.6,40.2-28.3l105.2,18.2L2624,1508.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2674.4,1218.2 2644.9,1388.2 2431.8,928.5 2549.5,948.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2360.2,1803.9 2242.4,1783.5 2105,1487.2 2134.5,1317.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2534.9,1846.1c-2.9,0-5.8-0.2-8.8-0.8h0l-438.9-76.1c-27.9-4.8-46.7-31.5-41.8-59.4L2183,916.4 c2.3-13.5,9.8-25.3,21-33.2c11.2-7.9,24.8-11,38.3-8.6l438.9,76.1c27.9,4.8,46.7,31.5,41.8,59.4l-137.6,793.4 C2581.1,1828.5,2559.4,1846.1,2534.9,1846.1z M2531.8,1812.7c9.9,1.7,19.3-4.9,21.1-14.8l137.6-793.4 c1.7-9.9-4.9-19.3-14.8-21.1l-438.9-76.1c-4.8-0.8-9.6,0.3-13.6,3.1c-4,2.8-6.6,7-7.5,11.8l-137.6,793.4 c-1.7,9.9,4.9,19.3,14.8,21.1L2531.8,1812.7L2531.8,1812.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2523.4,894.5c-0.7,0-1.4-0.1-2.2-0.2l-109-18.9c-6.8-1.2-11.4-7.6-10.2-14.4c1.2-6.8,7.6-11.4,14.5-10.2 l109,18.9c6.8,1.2,11.4,7.6,10.2,14.5C2534.7,890.2,2529.4,894.5,2523.4,894.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3823 -0.924 0.924 0.3823 1282.2687 2320.0688)",
    className: "st4",
    cx: 2376.5,
    cy: 200.9,
    rx: 359.1,
    ry: 454.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2440.2,256.7L2542,371c22.3,25,20.1,63.3-4.9,85.5c-24.9,22.2-63.2,20-85.4-5l-101.8-114.3 c17.1-10.3,33.4-22.4,48.8-36.1C2414.1,287.3,2427.9,272.5,2440.2,256.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2496.9,474.3c-17.4,0-34.7-7.1-47.2-21.1l-103.8-116.6l2.6-1.6c17-10.3,33.3-22.4,48.4-35.8 c15.2-13.5,29-28.3,41.3-44.1l1.8-2.4l103.8,116.6c23.1,26,20.8,65.9-5.1,89.1C2526.8,469,2511.8,474.3,2496.9,474.3z  M2353.6,337.8l99.9,112.1c21.3,23.9,58,26.1,81.9,4.8c23.9-21.3,26-58.1,4.7-82l-99.9-112.1c-11.9,15.1-25.4,29.3-40,42.4 C2385.7,315.9,2370,327.6,2353.6,337.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2440.2,256.7l64.4,72.3c-10.5,4.3-20.5,10.5-29.5,18.5c-26.9,24-38.6,58.7-34.2,92l-91.1-102.3 c17.1-10.3,33.4-22.4,48.8-36.1C2414.1,287.3,2427.9,272.5,2440.2,256.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2444.4,447.2l-98.5-110.6l2.6-1.6c17-10.3,33.3-22.4,48.4-35.8c15.2-13.5,29-28.3,41.3-44.1l1.8-2.4 l68.7,77.1l-3.3,1.3c-10.5,4.4-20.2,10.4-28.8,18.1c-25.3,22.6-37.8,56.1-33.3,89.8L2444.4,447.2z M2353.6,337.8l84,94.3 c-2-32.7,11.1-64.5,35.7-86.5c8.1-7.2,17.2-13.1,27-17.6l-60.1-67.5c-11.9,15.1-25.4,29.3-40,42.4 C2385.7,315.9,2370,327.6,2353.6,337.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2496.9,489.3c-21.5,0-42.9-8.8-58.4-26.1l-101.8-114.3c-3.5-3.9-5-9.1-4.2-14.2s3.8-9.7,8.2-12.4 c16.3-9.9,31.8-21.4,46.2-34.2c14.5-12.9,27.7-27.1,39.4-42.1c3.2-4.1,8-6.6,13.2-6.8c5.2-0.1,10.2,2,13.7,5.8l101.8,114.3 c28.6,32.1,25.8,81.6-6.4,110.2C2533.9,482.8,2515.4,489.3,2496.9,489.3z M2376.4,340.8l88.3,99.1c15.8,17.7,43,19.3,60.7,3.6 c8.6-7.7,13.7-18.2,14.4-29.7c0.7-11.5-3.2-22.5-10.9-31.1l-88.3-99.1c-9.4,10.7-19.6,21-30.4,30.6 C2399.5,323.7,2388.2,332.6,2376.4,340.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2547.7,17.1c25,163.3-71.8,317.2-222.7,369.1c-18.9,6.6-38.6,11.5-59,14.6c-20.4,3.1-40.7,4.3-60.6,3.7 c-159.5-4.3-298.1-122-323.1-285.5c-28.2-183.7,98-355.6,281.7-383.8C2347.7-292.8,2519.5-166.6,2547.7,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2215.3,407.2c-3.4,0-6.7,0-10-0.2c-163.8-4.4-300.7-125.3-325.5-287.6c-13.7-89.5,8.3-179,61.9-252.1 c53.6-73,132.4-120.8,221.9-134.5c89.5-13.7,179.1,8.2,252.1,61.9c73,53.6,120.8,132.4,134.5,221.9 c24.9,162.2-69.5,318.6-224.3,371.9c-19.1,6.6-39.1,11.6-59.5,14.7C2249.3,405.9,2232.2,407.2,2215.3,407.2z M2215.6-266.1 c-17,0-34.2,1.3-51.3,3.9c-88.2,13.5-165.8,60.6-218.7,132.6c-52.8,72-74.5,160.2-61,248.3c24.5,159.9,159.4,279,320.7,283.3 c19.9,0.6,40.1-0.6,60.2-3.7c20.1-3.1,39.8-8,58.6-14.5c152.6-52.5,245.5-206.6,221-366.4c-13.5-88.2-60.6-165.9-132.5-218.7 C2354.7-243.8,2286.2-266.1,2215.6-266.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2547.7,17.1c25,163.3-71.8,317.2-222.7,369.1c-18.9,6.6-38.6,11.5-59,14.6c-20.4,3.1-40.7,4.3-60.6,3.7 c-122.5-3.3-232.6-73.5-288.4-179.9c60.3,64.8,145.2,105,237,107.4c20,0.6,40.2-0.6,60.6-3.7c20.5-3.1,40.2-8,59-14.6 c150.8-51.9,247.7-205.8,222.7-369.1c-5.8-37.8-17.7-73.3-34.5-105.3C2506.1-113.1,2537.1-52.1,2547.7,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2215.3,407.2c-3.4,0-6.7,0-10-0.2c-122.2-3.3-233.6-72.7-290.5-181.2l-8.7-16.6l12.7,13.7 c60.8,65.4,146.6,104.3,235.3,106.6c19.9,0.6,40.1-0.6,60.2-3.7c20.1-3.1,39.8-8,58.6-14.5c152.6-52.5,245.5-206.6,221-366.4 c-5.6-36.8-17.2-72-34.3-104.6l-8.7-16.6l12.8,13.7c46.3,49.8,76.2,111.7,86.5,179.1c24.9,162.2-69.5,318.6-224.3,371.9 c-19.1,6.6-39.1,11.6-59.5,14.7C2249.3,405.9,2232.2,407.2,2215.3,407.2z M1928.3,239.8c58.4,97.5,162.9,159.2,277.1,162.3 c19.9,0.6,40.1-0.6,60.2-3.7c20.1-3.1,39.8-8,58.6-14.5c152.6-52.5,245.5-206.6,221-366.4c-9.2-60.2-34.3-116-72.9-162.5 c12.9,28.2,21.8,58.2,26.5,89.3c24.9,162.2-69.5,318.6-224.3,371.9c-19.1,6.6-39.1,11.6-59.5,14.7c-20.3,3.1-40.9,4.4-61.1,3.8 C2070.1,332.4,1988.9,298.1,1928.3,239.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 2215,
    cy: 68.1,
    r: 256.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2428.9-72.9C2383.1-96,2330-105.4,2275.6-97c-139.8,21.4-235.9,152.2-214.5,292.1 c5.8,37.8,19.6,72.5,39.6,102.4c-72-36-126-105.1-139.1-190.6c-21.4-139.8,74.6-270.7,214.5-292.1 C2278.3-200.9,2375.6-153.9,2428.9-72.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2215.3,422.2c-3.5,0-7-0.1-10.5-0.2c-170.9-4.6-313.9-130.9-339.9-300.3c-14.3-93.5,8.6-186.9,64.6-263.2 c56-76.3,138.3-126.2,231.8-140.5c93.5-14.3,187,8.6,263.2,64.6c76.2,56,126.1,138.3,140.5,231.8l0,0 c26,169.4-72.6,332.7-234.3,388.3c-19.9,6.9-40.8,12.1-62.1,15.4C2250.9,420.9,2233,422.2,2215.3,422.2z M2215.6-251.1 c-16.3,0-32.6,1.2-49,3.8c-84.2,12.9-158.4,57.9-208.9,126.6c-50.5,68.7-71.1,153-58.2,237.2 c23.4,152.7,152.2,266.5,306.3,270.6c19,0.6,38.4-0.6,57.5-3.5c19.2-2.9,38-7.6,55.9-13.8c145.8-50.2,234.5-197.4,211.1-350l0,0 c-12.9-84.2-57.9-158.4-126.6-208.9C2348.4-229.8,2283-251.1,2215.6-251.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2214.4,342c-57.8,0-114-18.3-161.4-53.1c-58.9-43.3-97.5-106.9-108.6-179.2 c-11.1-72.3,6.6-144.6,49.9-203.5c43.3-59,106.9-97.5,179.2-108.6c149.2-22.9,289.2,79.9,312.1,229.1 c11.1,72.3-6.6,144.6-49.9,203.5c-43.3,59-106.9,97.5-179.2,108.6C2242.4,340.9,2228.3,342,2214.4,342z M2215.1-170.7 c-12,0-24.1,0.9-36.3,2.8c-63,9.7-118.6,43.3-156.3,94.7c-37.7,51.4-53.2,114.4-43.5,177.5c9.7,63,43.3,118.6,94.7,156.3 c51.4,37.7,114.4,53.2,177.5,43.5c63-9.7,118.6-43.3,156.3-94.7C2445.2,158,2460.6,95,2451,31.9l0,0 C2432.9-86,2330.9-170.7,2215.1-170.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2367.5,105.6c19,24.9-1.6,72.7-46.1,106.7c-44.5,34-96,41.4-115,16.5c-19-24.9,24.9-26.2,69.4-60.2 C2320.2,134.6,2348.4,80.7,2367.5,105.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2374.5,66.2c-13.4,0.6-20.1-13.4-20.9-31s4.7-32.1,18.2-32.7c13.4-0.6,24.9,13.2,25.7,30.8 C2398.2,51,2387.9,65.7,2374.5,66.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5229 -0.8524 0.8524 0.5229 990.9266 1873.3195)",
    className: "st4",
    cx: 2168.8,
    cy: 51.5,
    rx: 15.5,
    ry: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2161.6,107c0.8,5.4-2.9,10.4-8.2,11.2s-10.4-2.9-11.2-8.2c-0.8-5.4,2.9-10.4,8.2-11.2 C2155.8,98,2160.8,101.7,2161.6,107z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2298.9-21.8c0.8,5.4-2.9,10.4-8.2,11.2c-5.4,0.8-10.4-2.9-11.2-8.2s2.9-10.4,8.2-11.2 C2293.1-30.9,2298.1-27.2,2298.9-21.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3787 -0.9255 0.9255 0.3787 1301.9268 2109.167)",
    className: "st4",
    cx: 2222,
    cy: 84.9,
    rx: 12.8,
    ry: 12.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1925,465.8c-10.1-12.8-24.6-20.9-40.9-22.8l-211.9-24.8V257.8c0-33.7-27.4-61.1-61.1-61.1h-247.9 l-26-79.7c-10.4-32-45-49.6-77.1-39.2L894.9,196.6H403.4c-33.7,0-61.1,27.4-61.1,61.1v118.9l-230.5,75 c-15.5,5.1-28.2,15.9-35.6,30.4c-7.4,14.6-8.7,31.1-3.6,46.7l269.7,828.1v593.7c0,33.7,27.4,61.1,61.1,61.1h19.7l-3,25.9 c-3.9,33.5,20.1,63.9,53.6,67.8l116.8,13.7l6.3,19.2c5.1,15.5,15.9,28.2,30.4,35.6c8.7,4.4,18.1,6.7,27.7,6.7 c6.4,0,12.8-1,19-3l109.9-35.8l889.5,104.1c2.4,0.3,4.8,0.4,7.2,0.4c13.7,0,26.9-4.6,37.8-13.2c12.8-10.1,20.9-24.6,22.8-40.9 l44.1-376.5l37-12.1c15.5-5.1,28.2-15.9,35.6-30.4c7.4-14.6,8.7-31.1,3.6-46.7l-48.4-148.7l124.8-1066.9 C1939.6,494.6,1935.1,478.7,1925,465.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1605.2,2153.4L405.7,2013c-23.9-2.8-41.1-24.5-38.3-48.4L564.1,283.4c2.8-23.9,24.5-41.1,48.4-38.3 l1199.5,140.3c23.9,2.8,41.1,24.5,38.3,48.4l-196.7,1681.3C1650.9,2139,1629.2,2156.2,1605.2,2153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1610.3,2156.2c-1.8,0-3.6-0.1-5.4-0.3L405.4,2015.5c-12.2-1.4-23.2-7.5-30.8-17.2 c-7.6-9.7-11.1-21.7-9.6-34L561.6,283.1c1.4-12.2,7.5-23.2,17.2-30.8c9.7-7.6,21.7-11,34-9.6l1199.5,140.3 c25.3,3,43.4,25.9,40.5,51.2l-196.7,1681.3C1653.4,2138.8,1633.4,2156.2,1610.3,2156.2z M1605.5,2150.9 c22.5,2.7,43-13.5,45.6-36.1l196.7-1681.3c2.6-22.5-13.5-43-36.1-45.6L612.2,247.6c-10.9-1.3-21.7,1.8-30.3,8.6 c-8.6,6.8-14.1,16.6-15.3,27.5L369.9,1964.9c-1.3,10.9,1.8,21.7,8.6,30.3c6.8,8.6,16.6,14.1,27.5,15.3L1605.5,2150.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1805.4,468.8l-196.7,1681.3c-0.1,1.2-0.3,2.3-0.6,3.5c-0.9-0.1-1.8-0.2-2.8-0.2L405.7,2013 c-24-2.8-41.1-24.5-38.3-48.4L564.1,283.4c0.1-1.2,0.3-2.3,0.5-3.5c1,0,1.9,0.1,2.9,0.2l1199.5,140.3 C1791,423.2,1808.2,444.9,1805.4,468.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1610.4,2171.2c-2.4,0-4.7-0.1-7.1-0.4c0,0,0,0,0,0L403.7,2030.4c-16.2-1.9-30.7-10-40.9-22.8 c-10.1-12.8-14.7-28.8-12.8-45L546.7,281.3c1.9-16.2,10-30.7,22.8-40.9c12.8-10.1,28.8-14.7,45-12.8L1814.1,368 c33.5,3.9,57.5,34.4,53.6,67.8L1671,2117.1C1667.4,2148.2,1640.9,2171.2,1610.4,2171.2z M1607.3,2136 c14.3,1.7,27.3-8.6,29-22.9L1833,431.8c1.7-14.3-8.6-27.3-22.9-29L610.5,262.5c-6.9-0.8-13.8,1.1-19.2,5.5 c-5.5,4.3-8.9,10.5-9.7,17.5L384.8,1966.6c-0.8,6.9,1.1,13.8,5.5,19.2c4.3,5.5,10.5,8.9,17.5,9.7L1607.3,2136L1607.3,2136z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1746.7,1711.9l-85.6,27.9L862.1,2000l-263.8,85.9c-22.9,7.4-47.5-5.1-55-28l-18.8-57.9l-158.3-486.2 L19.2,448.3c-7.4-22.9,5.1-47.6,28-55l319-103.9L579.5,220l616-200.6c22.9-7.5,47.5,5,55,28l56.2,172.6l354.4,1088.2 l113.5,348.7C1782.2,1679.8,1769.6,1704.4,1746.7,1711.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M584.8,2090.5c-7.2,0-14.3-1.7-20.9-5.1c-11-5.6-19.1-15.1-22.9-26.8L16.8,449.1 c-7.9-24.2,5.4-50.3,29.6-58.2L1194.8,17c24.2-7.9,50.2,5.4,58.2,29.6L1777,1656.1c3.8,11.7,2.9,24.2-2.7,35.2 c-5.6,11-15.1,19.1-26.8,23h0l-1148.4,374C594.4,2089.8,589.6,2090.5,584.8,2090.5z M1209,19.7c-4.2,0-8.5,0.6-12.7,2 L47.9,395.7c-21.6,7-33.4,30.3-26.4,51.9l524.2,1609.5c3.4,10.4,10.7,18.9,20.5,23.9c9.8,5,20.9,5.9,31.4,2.5l1148.4-374 c10.5-3.4,19-10.7,23.9-20.5c5-9.8,5.8-20.9,2.4-31.4L1248.2,48.1C1242.5,30.8,1226.3,19.7,1209,19.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1661.1,1308.2v431.6L862.1,2000H573.7l-3.2-10l-158.4-486.2l-46-141.2V263.6c0-24.1,19.5-43.7,43.6-43.7 h897L1661.1,1308.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M862.5,2002.5H571.9l-3.8-11.7l-204.5-627.9V263.6c0-25.4,20.7-46.1,46.1-46.1h898.8l355,1090.7v433.4 L862.5,2002.5z M575.5,1997.5h286.1l796.9-259.5v-429.4L1305,222.5H409.8c-22.7,0-41.1,18.5-41.1,41.1v1098.5L575.5,1997.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M584.8,2105.5c-9.5,0-18.9-2.2-27.7-6.7c-14.6-7.4-25.4-20-30.4-35.6L2.6,453.7 c-10.4-32.1,7.1-66.6,39.2-77.1l1148.4-374c32.1-10.4,66.6,7.2,77.1,39.2l524.1,1609.5c5.1,15.5,3.8,32.1-3.6,46.7 c-7.4,14.6-20,25.4-35.6,30.4l-1148.4,374C597.5,2104.5,591.1,2105.5,584.8,2105.5z M1209,34.7c-2.7,0-5.4,0.4-8.1,1.3 L52.6,410c-13.7,4.5-21.2,19.2-16.8,32.9L560,2052.4c2.2,6.6,6.8,12,13,15.2c6.2,3.2,13.3,3.7,19.9,1.6l1148.4-374h0 c6.6-2.2,12-6.8,15.2-13c3.2-6.2,3.7-13.3,1.6-19.9L1233.9,52.8C1230.3,41.7,1220,34.7,1209,34.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1541.1,1919.1H333.4c-24.1,0-43.6-19.5-43.6-43.6V182.8c0-24.1,19.5-43.6,43.6-43.6h1207.7 c24.1,0,43.6,19.5,43.6,43.6v1692.7C1584.7,1899.6,1565.2,1919.1,1541.1,1919.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1541.1,1921.6H333.4c-25.4,0-46.1-20.7-46.1-46.1V182.8c0-25.4,20.7-46.1,46.1-46.1h1207.7 c25.4,0,46.1,20.7,46.1,46.1v1692.7C1587.2,1900.9,1566.5,1921.6,1541.1,1921.6z M333.4,141.6c-22.7,0-41.1,18.5-41.1,41.1 v1692.7c0,22.7,18.5,41.1,41.1,41.1h1207.7c22.7,0,41.1-18.5,41.1-41.1V182.8c0-22.7-18.5-41.1-41.1-41.1H333.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1541.1,1936.6H333.4c-33.7,0-61.1-27.4-61.1-61.1V182.8c0-33.7,27.4-61.1,61.1-61.1h1207.7 c33.7,0,61.1,27.4,61.1,61.1v1692.7C1602.2,1909.2,1574.8,1936.6,1541.1,1936.6z M333.4,156.6c-14.4,0-26.1,11.7-26.1,26.1 v1692.7c0,14.4,11.7,26.1,26.1,26.1h1207.7c14.4,0,26.1-11.7,26.1-26.1V182.8c0-14.4-11.7-26.1-26.1-26.1H333.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -97.7204 816.8944)",
    className: "st15",
    cx: 937.2,
    cy: 526.4,
    rx: 126.7,
    ry: 126.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1145.7,881.4h-417c-21.4,0-36.6-20.4-31-41c23.8-87.5,122-153.1,239.5-153.1 c117.5,0,215.8,65.6,239.5,153.1C1182.3,861,1167.1,881.4,1145.7,881.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1281.9,1025.1h-63.1c-9.7,0-17.5-7.8-17.5-17.5c0-9.7,7.8-17.5,17.5-17.5h63.1c9.7,0,17.5,7.8,17.5,17.5 C1299.4,1017.3,1291.6,1025.1,1281.9,1025.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1146.7,1025.1H872.3c-9.7,0-17.5-7.8-17.5-17.5c0-9.7,7.8-17.5,17.5-17.5h274.4 c9.7,0,17.5,7.8,17.5,17.5C1164.2,1017.3,1156.4,1025.1,1146.7,1025.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1085,1116.4H810.6c-9.7,0-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5H1085c9.7,0,17.5,7.8,17.5,17.5 S1094.7,1116.4,1085,1116.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M942.9,1335.2H668.5c-9.7,0-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5h274.4c9.7,0,17.5,7.8,17.5,17.5 S952.6,1335.2,942.9,1335.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M817.2,1270.2H668.5c-9.7,0-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5h148.8c9.7,0,17.5,7.8,17.5,17.5 S826.9,1270.2,817.2,1270.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M836,1493.5H668.5c-9.7,0-17.5-7.8-17.5-17.5c0-9.7,7.8-17.5,17.5-17.5H836c9.7,0,17.5,7.8,17.5,17.5 C853.5,1485.7,845.6,1493.5,836,1493.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1072.2,1553.9H668.5c-9.7,0-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5h403.8c9.7,0,17.5,7.8,17.5,17.5 S1081.9,1553.9,1072.2,1553.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M942.9,1763.9H668.5c-9.7,0-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5h274.4c9.7,0,17.5,7.8,17.5,17.5 S952.6,1763.9,942.9,1763.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M784.7,1025.1H552.2c-9.7,0-17.5-7.8-17.5-17.5c0-9.7,7.8-17.5,17.5-17.5h232.5c9.7,0,17.5,7.8,17.5,17.5 C802.2,1017.3,794.4,1025.1,784.7,1025.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M505.4,1329.5h-84.5c-12.6,0-22.9-10.2-22.9-22.9v-84.5c0-12.6,10.2-22.9,22.9-22.9h84.5 c12.6,0,22.9,10.2,22.9,22.9v84.5C528.3,1319.2,518.1,1329.5,505.4,1329.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M505.4,1546.1h-84.5c-12.6,0-22.9-10.2-22.9-22.9v-84.5c0-12.6,10.2-22.9,22.9-22.9h84.5 c12.6,0,22.9,10.2,22.9,22.9v84.5C528.3,1535.9,518.1,1546.1,505.4,1546.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M505.4,1762.8h-84.5c-12.6,0-22.9-10.2-22.9-22.9v-84.5c0-12.6,10.2-22.9,22.9-22.9h84.5 c12.6,0,22.9,10.2,22.9,22.9v84.5C528.3,1752.6,518.1,1762.8,505.4,1762.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1543.1,633.4v1201.8c0,22.7-18.5,41.2-41.2,41.2H289.7v-0.9C968.8,1851,1395,1434,1543.1,633.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M638.8,700.6L580.9,876c-2.4,7.3-9.2,12-16.6,12c-1.8,0-3.6-0.3-5.5-0.9c-9.2-3-14.2-12.9-11.1-22.1 l6.1-18.6c-14.3-7.3-23.1-22-23.1-37.7c0-4.3,0.7-8.8,2.1-13.2c6.7-20.1,26.9-31.9,47.1-28.5l25.6-77.5 c5-15.2-3.3-31.7-18.6-36.8l-22.4-7.4l-243,734.7c-3.1,9.4-8.6,17.9-16,24.6l-15.8,14V798.8l93-281c4.6-14,14.5-24.8,28.6-31.5 l18.2-55.2c7.4-22.4,23-40.5,44-51.1c21.1-10.6,45-12.4,67.3-5c46.2,15.2,71.3,65.2,56.1,111.3l-17.7,53.7 c5.3,9.2,8,18.9,8,28.5c0,5.3-0.9,10.7-2.6,16l-9.2,27.8l22.4,7.3c16.2,5.3,29.5,16.8,37.2,32.1 C642.8,666.9,644.1,684.3,638.8,700.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M334.4,718.9c-1.9-5.6-2.6-11.6-1.9-17.5l20-165.6l133.5,100.1c4.9,3.6,8.8,8.3,11.5,13.9 C508.1,690.5,355.5,755.4,334.4,718.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.7,732c-13.8,0-24.7-3.5-29.5-11.9l-0.2-0.4c-2.1-6-2.8-12.4-2-18.6l20.5-169.9l136.9,102.7 c5.3,4,9.4,8.9,12.2,14.8c6.2,23.6-33.9,51.7-73.8,68.1C403.9,725.8,380.2,732,361.7,732z M336.6,717.8 c8.6,14.3,44.4,12,87.4-5.7c39.1-16.1,76-42.4,71-61.7c-2.3-4.7-6-9-10.6-12.5l-130-97.5l-19.5,161.3 C334.3,707.1,334.9,712.7,336.6,717.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M342.9,614.9l9.5-79l63.7,47.8C395,597.2,367.4,609,342.9,614.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M340,618.1l10.5-86.9l70,52.5l-3,1.9c-21.5,13.9-49.1,25.7-74,31.6L340,618.1z M354.4,540.4l-8.6,71.1 c22.2-5.7,46.4-16,65.9-28.1L354.4,540.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.6,743.4c-19.1,0-34.3-5.9-40.7-20.9c-0.8-2-1.2-4.1-1.1-6.2c0.5-7.5,7-13.2,14.4-12.7 c5.5,0.4,9.9,3.9,11.8,8.6c3.7,5.9,32.9,7.2,76.8-11.5c19.8-8.4,37.7-19.1,49.1-29.3c9.8-8.7,13.2-15.6,12.2-18.4 c-2.1-4.8-1.4-10.6,2.4-14.7c5.1-5.5,13.6-6,19.1-0.9l0.1,0.1c1.4,1.3,2.6,2.9,3.3,4.7c13.6,31.9-30.1,64-75.6,83.5 C409.4,735.9,383.1,743.4,361.6,743.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M524.3,873c-1.8,0-3.7-0.3-5.5-0.9c-9.2-3-14.2-12.9-11.1-22.1l57.8-175.4c2.4-7.4,1.8-15.3-1.7-22.2 c-3.5-6.9-9.5-12.1-16.9-14.6L489.9,619c-9.2-3-14.2-12.9-11.1-22.1c3-9.2,12.9-14.2,22.1-11.1l57.1,18.8 c16.3,5.4,29.5,16.7,37.2,32c7.7,15.3,9,32.7,3.6,49L541,861C538.5,868.4,531.7,873,524.3,873z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M518.3,532.9L384,488.6l22.1-67.1c12.2-37.1,52.2-57.2,89.2-45h0c37.1,12.2,57.2,52.2,45,89.2 L518.3,532.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M495.4,376.5c-6.1-2-12.3-3.1-18.5-3.4c22.7,17.9,33.1,48.6,23.5,77.6l-22.1,67.1L384.6,487l-0.5,1.6 l134.2,44.2l22.1-67.1C552.6,428.7,532.4,388.7,495.4,376.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M528,399c-34.2-6.5-68.9,13.3-80.1,47.3l-18.8,57.2L384,488.6l22.1-67.2c12.2-37,52.1-57.2,89.2-45 C508.8,380.9,519.9,388.9,528,399z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M518.3,550.4c-1.8,0-3.7-0.3-5.5-0.9l-134.2-44.2c-4.4-1.5-8.1-4.6-10.1-8.7c-2.1-4.1-2.4-9-1-13.4 l22.1-67.1c15.2-46.2,65.2-71.4,111.3-56.1c46.2,15.2,71.4,65.2,56.1,111.3l-22.1,67.1c-1.5,4.4-4.6,8.1-8.7,10.1 C523.7,549.7,521,550.4,518.3,550.4z M406.1,477.5l101,33.3l16.6-50.5c9.2-27.8-6-58-33.9-67.1c-27.8-9.2-58,6-67.1,33.9 L406.1,477.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M260,1369.6L260,1369.6c-1.8,2.6-3.8,4.9-6.2,7.1l-125,111L95.1,1324c-0.8-3.5-1-7.1-0.8-10.7 c0-0.2,0.1-0.3,0.1-0.3c0.1-1.6,0.3-3.2,0.7-4.8c0.3-1.6,0.7-3.1,1.2-4.6l263-795.4c20.6-62.6,189.6-7,168.9,55.7l-263.2,795.7 c-0.4,1.4-0.9,2.6-1.5,3.9l-0.1,0.3C262.4,1365.7,261.3,1367.8,260,1369.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M260,1369.6L260,1369.6c-1.8,2.6-3.8,4.9-6.2,7.1l-125,111L95.1,1324c-0.8-3.5-1-7.1-0.8-10.7 c0-0.2,0.1-0.3,0.1-0.3C109.9,1267.7,275.3,1324.1,260,1369.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M528.1,563.9l-263.2,795.7c-0.4,1.3-1,2.6-1.5,3.8l-0.1,0.3c-2.2,4.9-5.5,9.3-9.6,12.9l-125,111.1 l6.9-28.9l82.2-122.4c4.1-3.7-3.8,0.8-1.6-4.1l0.1-0.3c0.6-1.2,1.1-2.5,1.5-3.8L481,532.5c4.6-13.8-0.1-27.3-10.4-39.2 C507.8,508.5,537.5,535.4,528.1,563.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M437.6,483.5c-12.7,4-22.3,11.8-26.3,23.9l-263.1,795.3c-2.2,6.6-2.6,13.7-1.2,20.4l0.6,140.9l-18.8,23.8 L95.1,1324c-1.5-6.7-1-13.8,1.2-20.4l263.1-795.4C367.8,482.2,402,476.6,437.6,483.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.8,1505.3c-1.8,0-3.7-0.3-5.5-0.9c-5.9-2-10.4-7-11.6-13.1l-33.7-163.8c-2-9.6-1.5-19.8,1.7-29.4 l263.1-795.4c6.3-19.2,22.7-32.5,46.1-37.3c44.8-9.3,110.7,12.4,141.2,46.5c15.9,17.8,21.2,38.2,14.8,57.4c0,0,0,0,0,0 l-263.2,795.7c-3.1,9.4-8.7,17.9-16.1,24.6l-125.1,111.2C137.1,1503.7,133,1505.3,128.8,1505.3z M411.3,498.2 c-5.5,0-10.6,0.5-15.4,1.5c-16.5,3.4-19.1,11.4-20,14l-263.1,795.4c-1.2,3.7-1.5,7.6-0.7,11.2l27.6,134.2l102.4-91 c2.9-2.6,4.9-5.8,6.2-9.5l263.2-795.7l0,0c0.9-2.6,3.5-10.6-7.7-23.2C485,514.2,443.2,498.2,411.3,498.2z M528.1,563.9 L528.1,563.9L528.1,563.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M491,689.8c-1.7,0-3.5-0.3-5.3-0.8c-8.8-2.9-13.6-12.4-10.7-21.2c0.9-2.7-2.5-9.2-12.1-16.9 c-11.7-9.4-29.8-18.5-49.7-25.1c-44.1-14.5-72.5-9.6-74.6-2.9c-2.9,8.8-12.4,13.6-21.2,10.7c-8.8-2.9-13.6-12.4-10.7-21.2 c3.4-10.4,14.5-28,50.3-29.5c19.1-0.7,42.8,3.1,66.7,11c23.9,7.9,45.3,18.8,60.2,30.8c28,22.5,26.4,43.2,23,53.6 C504.6,685.3,498,689.8,491,689.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M519.8,834l2.9,1l26.5-80.4l-2.9-1c-22.2-7.3-46.1,4.8-53.5,27l0,0C485.5,802.8,497.6,826.7,519.8,834z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M259.9,1386.4c-1.8,0-3.6-0.3-5.4-0.9c-8.8-3-13.5-12.5-10.5-21.3c0.6-1.7-1.2-5.2-4.5-9 c-21.2-24.3-88.6-47.3-120.2-41.1c-4.9,1-8.5,2.7-9.1,4.4c-3,8.8-12.5,13.4-21.3,10.5c-8.8-3-13.5-12.5-10.5-21.3 c3.3-9.6,11.9-22,34.4-26.5c43.4-8.5,122.9,18.6,152,51.9c15.1,17.2,14.3,32.3,11,42C273.4,1382,266.9,1386.4,259.9,1386.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.8,1551.5c-1.8,0-3.7-0.3-5.5-0.9c-9.2-3-14.2-12.9-11.1-22.1l17.5-52.9c3-9.2,12.9-14.2,22.1-11.1 c9.2,3,14.2,12.9,11.1,22.1l-17.5,52.9C129,1546.8,122.1,1551.5,114.8,1551.5z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsNew);
export default __webpack_public_path__ + "static/media/documents-new.37fb9afa.svg";
export { ForwardRef as ReactComponent };